var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"focus-background",class:{'focus-background-show':_vm.loaded},style:('background-image: url(' + _vm.src + ')')},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }